@if (!isIplexDeviceConnectMode && !isBrianApp) {
  <div [class]="'network-icon'" (click)="openConnectDialog()" [matTooltip]="'offlineHeader.switchOnDeviceMode' | translate">
    <svg>
      <use xlink:href="assets/icons/iplexDisconnected.svg#iplexDisconnected" href="assets/icons/iplexDisconnected.svg#iplexDisconnected" />
    </svg>
  </div>
}

@if (isIplexDeviceConnectMode && !isBrianApp) {
  <div [class]="'network-icon'" cdkMenuItem [cdkMenuTriggerFor]="menu" [matTooltip]="'offlineHeader.switchOffDeviceMode' | translate">
    <svg>
      <use xlink:href="assets/icons/iplexConnected.svg#iplexConnected" href="assets/icons/iplexConnected.svg#iplexConnected" />
    </svg>
  </div>
}

<ng-template #menu>
  <div class="main-menu" cdkMenu>
    <div class="sub-menu admin">
      <div class="menu-title">{{ "offlineHeader.IPLEXMenu" | translate }}</div>
      <ng-container *ngIf="isDesktop">
        <ng-container *ngIf="isIplexDeviceConnectMode">
          <!-- Direct File Transfer -->
          <div class="row" (click)="openDirectFileTransferDialog()">
            <a class="sidenaviSub-itemLink" fxLayout="column" fxLayoutGap="5px">
              <span class="sidenaviSub-navText">{{ "offlineHeader.directFileTransfer" | translate }}</span>
            </a>
          </div>

          <!-- Advanced wireless settings -->
          <div class="row" (click)="openWifiSettingDialog()">
            <a class="sidenaviSub-itemLink" fxLayout="column" fxLayoutGap="5px">
              <span class="sidenaviSub-navText">{{ "offlineHeader.wifiSettings" | translate }}</span>
            </a>
          </div>

          <!-- Unlink with IPLEX -->
          <div class="row" (click)="switchOffIplexDeviceConnectMode()">
            <a class="sidenaviSub-itemLink with-border-top" fxLayout="column" fxLayoutGap="5px">
              <span class="sidenaviSub-navText">{{ "offlineHeader.switchOffDeviceMode" | translate }}</span>
            </a>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
